const initialState = {
	auth: null,
	locked: false,
	autoLock: {
		warningTimeout: 1,
		lockTimeout: 1,
	},
};

const authReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_AUTH':
			return {
				...state,
				auth: action.payload.value,
			};
		case 'USER_LOGOUT':
			return {
				...state,
				auth: null,
			};
		case 'SET_LOCKED':
			return {
				...state,
				locked: action.payload.value,
			};
		case 'SET_AUTO_LOCK_SETTINGS':
			return {
				...state,
				autoLock: action.payload.value,
			};
		case 'CROSS_TAB_SYNC':
			return {
				...state,
				...action.payload.value,
			};
		default:
			return state;
	}
};

export const setAuthActionCreator = value => ({
	type: 'SET_AUTH',
	payload: {
		value
	}
});

export const userLogoutActionCreator = () => ({
	type: 'USER_LOGOUT',
	payload: {}
});

export const setLockedActionCreator = value => ({
	type: 'SET_LOCKED',
	payload: {
		value
	}
});

export const setAutoLockSettingsActionCreator = value => ({
	type: 'SET_AUTO_LOCK_SETTINGS',
	payload: {
		value
	}
});

export const crossTabSyncAuthActionCreator = value => ({
	type: 'CROSS_TAB_SYNC',
	payload: {
		value
	}
});

export default authReducer;
